import React from "react";
import { GALLERY } from "@/lib/data";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-mrn-wood py-24 md:py-32 texture-grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-mrn-amber font-medium">
              A Closer Look
            </p>
            <h2 className="mt-4 headline-display text-mrn-cream text-4xl md:text-6xl">
              Every corner, <em className="text-mrn-sand font-light">felt in.</em>
            </h2>
          </div>
          <p className="max-w-md text-mrn-sand/80 text-base">
            Open-brick walls, warm tungsten light, hand-picked furniture and
            a courtyard made for long evenings.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {GALLERY.map((g, i) => (
            <figure
              key={i}
              data-testid={`gallery-tile-${i}`}
              className={`overflow-hidden rounded-2xl group ${
                g.span === "wide" ? "md:col-span-2" : ""
              } ${g.span === "tall" ? "row-span-2" : ""}`}
            >
              <img
                src={g.url}
                alt={g.alt}
                loading="lazy"
                className="w-full h-full object-cover aspect-[4/3] transition-transform duration-700 group-hover:scale-105"
              />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
